import { api } from './_client';
import type {
  DronesLegacyHoursListResponse,
  PilotsLegacyHoursListResponse,
  UpdateLegacyHoursRequest,
  UpdateLegacyHoursResponse,
} from '../../types/api';

export const legacyHoursApi = {
  // Get all drones with their legacy hours
  async getDronesLegacyHours(): Promise<DronesLegacyHoursListResponse> {
    const response = await api.get<DronesLegacyHoursListResponse>('/api/admin/legacy-hours/drones');
    return response.data;
  },

  // Update legacy hours for a specific drone
  async updateDroneLegacyHours(
    serialNumber: string,
    hours: UpdateLegacyHoursRequest
  ): Promise<UpdateLegacyHoursResponse> {
    const response = await api.put<UpdateLegacyHoursResponse>(
      `/api/admin/legacy-hours/drones/${encodeURIComponent(serialNumber)}`,
      hours
    );
    return response.data;
  },

  // Get all pilots with their legacy flight hours
  async getPilotsLegacyHours(): Promise<PilotsLegacyHoursListResponse> {
    const response = await api.get<PilotsLegacyHoursListResponse>('/api/admin/legacy-hours/pilots');
    return response.data;
  },

  // Update legacy flight hours for a specific pilot
  async updatePilotLegacyHours(
    userId: string,
    hours: UpdateLegacyHoursRequest
  ): Promise<UpdateLegacyHoursResponse> {
    const response = await api.put<UpdateLegacyHoursResponse>(
      `/api/admin/legacy-hours/pilots/${encodeURIComponent(userId)}`,
      hours
    );
    return response.data;
  },
};
